import React from 'react';
import './App.css';
import axios from "axios";
import CONFIG from './config';

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Connexion from './pages/public/connexion/Connexion';
import Dossier from './pages/client/dossier/Dossier';
import Deconnexion from './pages/public/deconnexion/Deconnexion';
import LayoutClient from './components/layouts/LayoutClient';
import LayoutDefaut from './components/layouts/LayoutDefaut';
import LayoutIntranet from './components/layouts/LayoutIntranet';
import MdpOublie from './pages/public/mdp_oublie/MdpOublie';
import NoPage from './pages/NoPage';
import NouveauMdp from './pages/public/nouveau_mdp/NouveauMdp';
import RenvoyerMail from './pages/public/renvoyer_mail/RenvoyerMail';
import Verification from './pages/public/verification/Verification';
import InscriptionClient from './pages/public/inscription_client/InscriptionClient';
import InscriptionIntranet from './pages/public/inscription_intranet/InscriptionIntranet';
import ListCommerciaux from './pages/intranet/commerciaux/ListCommerciaux';
import ListUtilisateurs from './pages/intranet/utilisateurs/ListUtilisateurs';
import Compta from './pages/intranet/comptabilite/Compta';
import Questionnaire from './pages/client/questionnaire/Questionnaire';
import VueEnsemble from './pages/intranet/vue_ensemble/VueEnsemble';
import Configuration from './pages/intranet/configuration/Configuration';
import Fiche from './pages/intranet/fiche/Fiche';
import QuestionnaireLocataire from './pages/client/questionnaire_locataire/QuestionnaireLocataire';
import QuestionnaireGarant from './pages/client/questionnaire_garant/QuestionnaireGarant';
import CGU from './pages/public/rgpd/CGU';
import Mentions from './pages/public/rgpd/Mentions';
import PolitiqueDonnees from './pages/public/rgpd/PolitiqueDonnees';


function App() {
  const [current, setCurrent] = React.useState(undefined);

  // React.useEffect(() => {
  axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
    .then((response) => {
      switch (response.status) {
        case 200:
          if (current === undefined || current === null || response.data.roles.role_client !== current.roles.role_client)
            setCurrent(response.data);
          break;

        default:
          break;
      }
    })
    .catch((e) => {
      setCurrent(null);
    });
  // }, []);

  return (<>{current !== undefined && (
    <BrowserRouter basename="/relocation">
      <Routes>
        <Route path="/" element={<LayoutDefaut />}>
          <Route path="connexion" element={<Connexion />} />
          <Route path="deconnexion" element={<Deconnexion />} />
          <Route path="inscription_client/:id?" element={<InscriptionClient />} />
          <Route path="inscription_intranet" element={<InscriptionIntranet />} />
          <Route path="deconnexion" element={<Deconnexion />} />
          <Route path="mdp_oublie" element={<MdpOublie />} />
          <Route path="nouveau_mdp" element={<NouveauMdp />} />
          <Route path="renvoyer_mail" element={<RenvoyerMail />} />
          <Route path="verification" element={<Verification />} />
          <Route path="cgu" element={<CGU />} />
          <Route path="mentions" element={<Mentions />} />
          <Route path="politique" element={<PolitiqueDonnees />} />

          <Route index element={<Navigate to="/connexion" />} />
          <Route path="*" element={<Navigate to="/connexion" />} />
        </Route>

        {current !== null && (current.roles.role_client) &&
          <Route path="/client/" element={<LayoutClient current={current} />}>
            <Route path="questionnaire" element={<Questionnaire />} />
            <Route path="questionnaire_locataire/:id" element={<QuestionnaireLocataire />} />
            <Route path="questionnaire_garant/:id" element={<QuestionnaireGarant />} />
            <Route path="dossier" element={<Dossier />} />

            <Route index element={<Navigate to="/connexion" />} />
            <Route path="*" element={<Navigate to="/connexion" />} />
          </Route>
        }

        {current !== null &&
          <Route path="/intranet/" element={<LayoutIntranet current={current} />}>
            {(current.roles.role_admin_write || current.roles.role_admin_read || current.roles.role_commercial) &&
              <Route path="vue_ensemble" element={<VueEnsemble />} />
            }
            {(current.roles.role_admin_write || current.roles.role_admin_read) &&
              <Route path="commerciaux" element={<ListCommerciaux />} />
            }
            {(current.roles.role_admin_write || current.roles.role_admin_read) &&
              <Route path="utilisateurs" element={<ListUtilisateurs />} />
            }
            {(current.roles.role_comptable) &&
              <Route path="comptabilite" element={<Compta />} />
            }
            {(current.roles.role_admin_write) &&
              <Route path="configuration" element={<Configuration />} />
            }
            {(current.roles.role_admin_write || current.roles.role_admin_read || current.roles.role_commercial) &&
              <Route path="fiche/:id" element={<Fiche current={current} />} />
            }

            <Route index element={<Navigate to="/connexion" />} />
            <Route path="*" element={<Navigate to="/connexion" />} />
          </Route>
        }
      </Routes>
    </BrowserRouter>
  )}</>);
}

export default App;
